import { setUnchangedPositions, retainKeys } from '@moleculeone/draw';
import { M4 } from '@moleculeone/utils';

import { MOL_MOUSE_EVENT, MOUSE_DOWN, MOUSE_MOVE, MOUSE_UP, MOVE_MODE } from '../../../../etc/constants';
import { updateMols, updateState } from '../../../state';

export function effect(state, action) {
  if (action.type !== MOL_MOUSE_EVENT) {
    return {};
  }

  return baseEffect(state.mols, state.mode, state.selected, action.event, state.mouse.molIndex);
}

function baseEffect(mols, mode, selected, event, molIndex) {
  const data = mode.data;
  let newData = initial.data;
  let newMol = mols[molIndex];
  let selection = selected[molIndex];

  if (event.type === MOUSE_MOVE) {
    return {};
  }

  if (event.type === MOUSE_DOWN && data.start != null) {
    //
  } else if (event.type === MOUSE_UP && data.start == null) {
    //
  } else if (event.type === MOUSE_DOWN && data.start == null) {
    if (event.atom) {
      newData = {
        start: event.svgPos,
        selected: selection.length === 0 ? [event.idx] : selection,
      };
    } else {
      newData = {
        start: event.svgPos,
        selected: selection,
      };
    }
  } else if (event.type === MOUSE_UP && data.start != null) {
    newMol = move(mols[molIndex], data.start, data.selected, event.svgPos);
  }
  return {
    mols: updateMols(mols, newMol, molIndex),
    mode: updateState(mode, { data: newData }),
  };
}

export function move(mol, start, selected, now) {
  const group = selected.length === 0 ? mol.positions : retainKeys(mol.positions, selected);
  const mat = M4.mulM(M4.moveTo(now), M4.moveFrom(start));
  const newPositions = selected.length === 0 ? M4.map(mat, group) : updateState(mol.positions, M4.map(mat, group));
  return setUnchangedPositions(mol, newPositions);
}

export function preview(state) {
  const data = state.mode.data;
  const { lastMove, molIndex } = state.mouse;
  if (lastMove != null && data.start != null) {
    return move(state.mols[molIndex], data.start, data.selected, lastMove.svgPos);
  }
  return null;
}

function cleanup(mode, mol) {
  if (mode.data.selected != null) {
    for (const key of mode.data.selected) {
      if (mol.atoms[key] == null) {
        return trait.initial;
      }
    }
  }
  return mode;
}

const initial = {
  type: MOVE_MODE,
  data: {},
};

export const trait = {
  type: MOVE_MODE,
  initial,
  effect,
  preview,
  cleanup,
};
